import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

var marked = require('marked');
marked.setOptions({
  gfm: true,
  tables: true,
  breaks: true,
  sanitize: true
});

import Research_Item from '../components/Research_Item';
import Container from '../components/Shared/Container';
import InnerContainer from '../components/Shared/InnerContainer';
import SectionHeader from '../components/Shared/SectionHeader';
import SectionText from '../components/Shared/SectionText';

const ResearchPage = ({data}) => (
  <div style={{ minHeight: '100vh'}}>
    <Container research>
      <InnerContainer light>
        <SectionHeader light>Research</SectionHeader>
          <SectionText dangerouslySetInnerHTML={
            {__html: marked(data.allContentfulPage.edges[0].node.mainText.body.body,
            {sanitize: true})}}
          />
      </InnerContainer>
    </Container>
    <Container >
      <InnerContainer>
        <SectionHeader>Current Projects</SectionHeader>
      </InnerContainer>
      <InnerContainer>
        {data.allContentfulPage.edges[0].node.featuredItems &&
          data.allContentfulPage.edges[0].node.featuredItems.map((item, i) => {
          return (<Research_Item key={i} proj={item} i={i} />)
        })}
      </InnerContainer>
    </Container>
    <Container grey>
      <InnerContainer>
        <SectionHeader>Previous Projects</SectionHeader>
      </InnerContainer>
      <InnerContainer>
        {data.allContentfulPage.edges[0].node.additionalItems &&
          data.allContentfulPage.edges[0].node.additionalItems.map((item, i) => {
          return (<Research_Item key={i} proj={item} i={i} />)
        })}
      </InnerContainer>
    </Container>
  </div>
)

export default ResearchPage;

export const query = graphql`
  query ResearchQuery {
    allContentfulPage (
    filter: {
      title: {
      eq: "Research"
    	}
    }
    ) {
    edges {
      node {
        title
        mainText {
          title
          body {
            body
          }
        }
        featuredItems {
          ... on ContentfulResearch {
            title
            institution
            description {
              description
            }
            order
            relavantPapers {
              title
              doiNumber
              abstractUrl
            }
          }
        }
        additionalItems {
          ... on ContentfulResearch {
            title
            institution
            description {
              description
            }
            order
            relavantPapers {
              title
              doiNumber
              abstractUrl
            }
          }
        }
      }
    }
  }
}
`;

// const Container = styled.div`
//   background-color: #eee;
//   flex-direction: column;
//   justify-content: center;
//   padding: 40px 10px;
//   min-height: 100vh;
//   font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
// `;
//
// const InnerContainer = styled.div`
//   max-width: 960px;
//   margin: auto;
//   padding: 20px;
//   color: #333;
// `;
//
// const SectionHeader = styled.h1`
//   text-align: center;
//   font-weight: 300;
// `;



// WEBPACK FOOTER //
// ./src/pages/research.js